//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { connect } from 'react-redux';
import Redux, { bindActionCreators } from 'redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'unison';

import { ICuralateStore } from '@models/AppState';
import { assetFeedsModalActions } from '@streams/actions/assetFeedsModalActions';
import StreamsDrawerAssetFeedsSourceList from '@streams/components/StreamsDrawerAssetFeedsSourceList';
import StreamsDrawerAssetFeedsUpdateSourcesButton from '@streams/components/StreamsDrawerAssetFeedsUpdateSourcesButton';

function mapStateToProps(state: ICuralateStore) {
  return {
    selectedStream: state.streams.streamsDrawer.selectedStream,
  };
}

function mapDispatchToProps(dispatch: Redux.Dispatch) {
  return {
    actions: {
      modalActions: bindActionCreators(assetFeedsModalActions, dispatch),
    },
  };
}

interface Props
  extends ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

export const StreamsDrawerAssetFeedsSetupModal = (props: Props) => {
  const { actions, selectedStream } = props;

  return (
    <Modal isOpen={true}>
      <ModalHeader
        onCancel={() => actions.modalActions.cancelUpdate(selectedStream)}
      >
        Edit Sources
      </ModalHeader>
      <ModalBody className='cu-d-block cu-wide-measure'>
        <div className='cu-mb-5'>
          Choose which sources you want to add media from.
        </div>
        <StreamsDrawerAssetFeedsSourceList />
      </ModalBody>
      <ModalFooter>
        <Button
          className='cu-button-secondary'
          onClick={() => actions.modalActions.cancelUpdate(selectedStream)}
        >
          Cancel
        </Button>
        <StreamsDrawerAssetFeedsUpdateSourcesButton
          buttonText='Save'
          className='cu-ml-2'
        />
      </ModalFooter>
    </Modal>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StreamsDrawerAssetFeedsSetupModal);
